import React from "react";
import { connect } from "react-redux";
import { ActivityFormOfflineDetailContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { portalService } from "apiServices";
import * as XLSX from "xlsx";
import moment from "moment";
import momentTZ from "moment-timezone";
import { toast } from "react-toastify";
import { RENDER_CHARACTER_REPLACE_BY_PERMISSION } from "utils/functions/string";
import {
  ACTIVITY_FORM_RENDER_STATUS,
  ACTIVITY_FORM_RENDER_CUS_STATUS,
  REGISTER_BY,
} from "utils/functions/activityForm";
import { IMG_PATH } from "utils/constants/imgPath";
import { MdAssignmentAdd } from "react-icons/md";
import queryString from "query-string";
import { ROUTE_PATH } from "utils/constants/routePath";
import {
  AnswerOnlineFormEditWidget,
  BtnActivityActionFormWidget,
  BtnApproveFormWidget,
  BtnUploadCerificateWidget,
} from "widgets";
import { Displays, Icons, Inputs, Modals, Tables } from "components";
import { PARSE_LIST_QUERY } from "utils/functions/listQuery";

class ActivityFormOfflineDetailContainer extends React.Component {
  state = {
    isLoading: true,
    dataRequests: [],
    pagination: null,
    perPage: 20,
  };

  componentDidMount() {
    const { perPage } = this.state;
    const query = this.props.router.location.search || `?limit=${perPage}`;
    this.setState(PARSE_LIST_QUERY(this.props.router.location.search, perPage));
    this.fetchData(query);
  }

  fetchData = async (queryString) => {
    let resArr = await Promise.all([
      portalService.GET_ACTIVITY_FORM_DETAIL(this.props.router.params.id),
      portalService.GET_ACTIVITY_FORM_HISTORY_BY_ACTIVITY_LIST(
        this.props.router.params.id,
        queryString,
      ),
    ]);
    if (resArr) {
      this.setState({
        data: resArr[0].data,
        activityHistorydata: {
          ...resArr[1],
          docs: resArr[1].data.docs.sort(
            (a, b) => statusSort[a.status] - statusSort[b.status],
          ),
        },
        selectedAmount: resArr[1].data.docs.filter((e) => e.is_selected).length,
        dataRequests: resArr[1]?.data?.docs?.filter(
          (item) => item.status === "6" || item.status === "7",
        ),
        pagination: {
          last_page: resArr[1].data.totalPages,
          current_page: resArr[1].data.page,
          total: resArr[1].data.totalDocs,
          per_page: resArr[1].data.limit,
        },
        isLoading: false,
        isBgLoading: false,
        isLoadingTable: false,
      });
    }
  };

  handleFilterKeyword = (e) => {
    const { perPage } = this.state;
    this.setState({
      filterQuery: e,
    });
    this.handleJoinQuery(e, perPage, 1);
  };

  handlePageClick = (e) => {
    const { filterQuery, perPage } = this.state;
    this.handleJoinQuery(filterQuery, perPage, e.selected + 1);
  };

  handlePerPageChange = (perPage) => {
    const { filterQuery } = this.state;
    this.setState({ perPage });
    this.handleJoinQuery(filterQuery, perPage, 1);
  };

  handleJoinQuery = (query, per_page, page) => {
    let joinQuery = query
      ? `${query}&limit=${per_page}&page=${page}`
      : `?limit=${per_page}&page=${page}`;
    this.setState({
      isLoadingTable: true,
    });
    this.props.router.navigate(
      `${ROUTE_PATH.ACTIVITY_FORM}/offline/${this.props.router.params.id}${joinQuery}`,
    );
    this.fetchData(joinQuery);
  };

  handleClickGifgPoint = async (permission, e) => {
    if (!permission || !permission.is_update) {
      toast.error("คุณไม่มีสิทธิ์ในการให้คะแนน");
    } else {
      this.setState({
        isBgLoading: true,
      });
      let params = {
        customer_id: e.customer_ref_id,
        activity_id: e.activity_ref_id,
        activity_history_id: e._id,
        member_type: e.member_type,
      };
      let res = await portalService.POST_ACTIVITY_HITORY_SCAN(params);
      if (res && res.status === 200) {
        this.fetchData();
      } else {
        toast.error("ไม่สำเร็จ");
      }
    }
  };

  handleExport = async (permission) => {
    const { data } = this.state;
    const { filterQuery } = this.state;
    let joinQuery = filterQuery
      ? `${filterQuery}&pagination=false`
      : `?pagination=false`;

    this.setState({
      isBgLoading: true,
    });
    let res = await portalService.GET_ACTIVITY_FORM_HISTORY_BY_ACTIVITY_LIST(
      this.props.router.params.id,
      joinQuery,
    );
    if (res && res.status === 200) {
      let wb = XLSX.utils.book_new();
      let ws_name = "SheetJS";
      /* make worksheet */
      let ws_data = res.data.docs
        .sort((a, b) => statusSort[a.status] - statusSort[b.status])
        .reduce((result, e, i) => {
          const renderAns = [];
          e.question_list.forEach((f) => {
            f.questions.forEach((g) => {
              if (!g.answer) {
                renderAns.push("-");
              } else {
                switch (g.type) {
                  case "3":
                    renderAns.push(IMG_PATH + g.answer);
                    break;
                  case "5":
                    renderAns.push(
                      momentTZ(
                        g.answer,
                        // , "YYYY-MM-DD"
                      )
                        .tz("Asia/Bangkok")
                        .format("DD/MM/YYYY"),
                    );
                    break;
                  default:
                    renderAns.push(g.answer);
                    break;
                }
              }
            });
          });

          result.push([
            i + 1,
            momentTZ(e.created_at)
              .tz("Asia/Bangkok")
              .format("DD/MM/YYYY HH:mm:ss"),
            e.submitted_at
              ? momentTZ(e.submitted_at)
                  .tz("Asia/Bangkok")
                  .format("DD/MM/YYYY HH:mm:ss")
              : "-",
            REGISTER_BY(e.member_type),
            `${RENDER_CHARACTER_REPLACE_BY_PERMISSION({
              ...permission,
              inputString: e.personal_first_name,
              action: "export",
            })} ${RENDER_CHARACTER_REPLACE_BY_PERMISSION({
              ...permission,
              inputString: e.personal_last_name,
              action: "export",
            })}`,
            e.personal_email,
            e.check_in,
            ACTIVITY_FORM_RENDER_STATUS(e.status).label,
            e.rejection_reason,
            ...renderAns,
          ]);
          return result;
        }, []);
      let renderQuestionColumn = [];
      if (res.data.docs.length > 0) {
        res.data.docs[0].question_list.forEach((f) => {
          f.questions.forEach((g, h) => {
            renderQuestionColumn.push(`Ans${f.page}/${h + 1}`);
          });
        });
      }
      ws_data.splice(0, 0, [
        "No",
        "Create Date",
        "Submit Date",
        "Register By",
        "Name",
        "Email",
        "Check in",
        "Approve",
        "Reject",
        ...renderQuestionColumn,
      ]);
      let ws = XLSX.utils.aoa_to_sheet(ws_data);
      let wscols = [
        { wch: 15 },
        { wch: 15 },
        { wch: 30 },
        { wch: 30 },
        { wch: 15 },
        { wch: 15 },
        { wch: 30 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
      ];
      ws["!cols"] = wscols;
      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, ws_name);
      XLSX.writeFile(
        wb,
        `act-report-${data.code}-${moment()
          .tz("Asia/Bangkok")
          .format("DD/MM/YYYY")}.xlsx`,
      );
      this.setState({
        isBgLoading: false,
      });
    }
  };

  handleBgLoading = (e) => {
    this.setState({
      isBgLoading: e,
    });
  };

  render() {
    const { authenRedux, router } = this.props;
    const {
      isLoading,
      isLoadingTable,
      isBgLoading,
      data,
      dataRequests,
      activityHistorydata,
      pagination,
      isShowModal,
      renderModal,
    } = this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find((e) => e.menu_key === "activity-form");
    return (
      <ActivityFormOfflineDetailContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        {isLoading ? (
          <Displays.Loading theme_standard_loading />
        ) : (
          <>
            <div className="block_section">
              <div className="title">ข้อมูลผู้เข้าร่วมกิจกรรม</div>
              <div className="body_row">
                <div className="b_left_col">
                  <div className="value_item_wrap">
                    <Displays.LabelValue
                      label={"รหัส"}
                      value={`${data.code}`}
                    />
                  </div>
                  <div className="value_item_wrap">
                    <Displays.LabelValue label={"ชื่อ"} value={data.name_th} />
                  </div>
                  {data.question_list && data.question_list.length > 0 && (
                    <>
                      <div className="title">คำถาม</div>
                      <div className="body pl_1">
                        {data.question_list &&
                          data.question_list.map((e) =>
                            e.questions.map((f, j) => (
                              <div key={j} className="question_row">
                                <div>
                                  หน้า {e.page} ข่้อ {j + 1}
                                </div>
                                <div
                                  className="question_label"
                                  dangerouslySetInnerHTML={{
                                    __html: f.question,
                                  }}
                                />
                                <div className="question_ans_block">
                                  {f.answer_list.map((g, k) => (
                                    <div key={k} className="ans_label">
                                      {`ตอบ ${k + 1} `}
                                      {g.ans}
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )),
                          )}
                      </div>
                    </>
                  )}

                  {dataRequests.length >= 1 && (
                    <div className="correction_requests_wrap">
                      <div className="title">
                        <span>
                          <Icons.BellIcon />
                        </span>
                        รายการร้องขอแก้ไขข้อมูล
                      </div>
                      <div className="requests_table">
                        <Tables.Standard
                          columns={COLUMNS_REQUESTS({
                            handleApproveeSuccess: () =>
                              this.fetchData(`?pagination=false`),
                            handleBgLoading: this.handleBgLoading,
                            onSuccess: () => {
                              this.setState({
                                isBgLoading: true,
                              });
                              this.fetchData(`?pagination=false`);
                            },
                          })}
                          data={dataRequests}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="filter_wrap">
              <Inputs.InputFilter
                theme_standard_input_filter
                dataFilter={dataFilter(router.location?.search)}
                btnLabel="ค้นหา"
                onQueryFilter={this.handleFilterKeyword}
                onExport={
                  permission &&
                  (permission.is_export || permission.is_export_condition)
                    ? () => this.handleExport(permission)
                    : false
                }
              />
            </div>
            {isLoadingTable ? (
              <Displays.Loading theme_standard_loading />
            ) : (
              <div className="body_table">
                <Tables.Standard
                  columns={
                    COLUMNS({
                      permission: permission,
                      data: data,
                      handleApproveeSuccess: () =>
                        this.fetchData(`?pagination=false`),
                      handleBgLoading: this.handleBgLoading,
                      onSuccess: () => {
                        this.setState({
                          isBgLoading: true,
                        });
                        this.fetchData(`?pagination=false`);
                      },
                    })
                    // this.renderColumn(data, permission)
                  }
                  data={activityHistorydata.docs}
                  showPagination
                  pagination={pagination}
                  handlePageClick={this.handlePageClick}
                  onChangePerPage={this.handlePerPageChange}
                />
              </div>
            )}
          </>
        )}
        <Modals.BodyEmpty
          isShowModal={isShowModal}
          onCloseModal={() => {
            this.setState({ isShowModal: false });
          }}
        >
          {renderModal}
        </Modals.BodyEmpty>
      </ActivityFormOfflineDetailContainerStyled>
    );
  }
}

const statusSort = { 2: 0, 1: 1, 3: 2, 4: 3 };

const dataFilter = (query) => {
  let initialValues = queryString.parse(query);
  return [
    {
      accessor: "personal_first_name",
      length: "311px",
      filter: {
        fieldQuery: "personal_first_name",
        defaultValue: initialValues["personal_first_name"],
        type: "text",
        label: "Name",
        placeholder: "Name",
      },
    },
    {
      accessor: "personal_email",
      length: "311px",
      filter: {
        fieldQuery: "personal_email",
        defaultValue: initialValues["personal_email"],
        type: "text",
        label: "Email",
        placeholder: "Email",
      },
    },
    {
      accessor: "personal_phone_number",
      length: "311px",
      filter: {
        fieldQuery: "personal_phone_number",
        defaultValue: initialValues["personal_phone_number"],
        type: "text",
        label: "Phone",
        placeholder: "Phone",
      },
    },
    {
      accessor: "member_type",
      length: "311px",
      filter: {
        fieldQuery: "member_type",
        defaultValue: initialValues["member_type"],
        type: "dropdown",
        label: "Register By",
        placeholder: "All",
        options: [
          {
            label: "All",
            value: "",
          },
          {
            label: "ไม่เป็นสมาชิก",
            value: "3",
          },
          {
            label: "บุคคล",
            value: "1",
          },
          {
            label: "องค์กร",
            value: "2",
          },
        ],
      },
    },
    {
      accessor: "status",
      length: "311px",
      filter: {
        fieldQuery: "status",
        defaultValue: initialValues["status"],
        type: "dropdown",
        label: "Status",
        placeholder: "All",
        options: [
          {
            label: "All",
            value: "",
          },
          {
            label: "สำเร็จ",
            value: "4",
          },
          {
            label: "รอประกาศผล",
            value: "1",
          },
          {
            label: "Reject",
            value: "2",
          },
          {
            label: "Draft",
            value: "5",
          },
        ],
      },
    },
  ];
};

const COLUMNS = ({
  data,
  permission,
  handleApproveeSuccess,
  handleBgLoading,
  onSuccess,
}) => {
  let temp = [
    {
      Header: <div style={{ textAlign: "left" }}>Create Date</div>,
      accessor: "created_at",
      Cell: (props) => (
        <div>
          {momentTZ(props.value)
            .tz("Asia/Bangkok")
            .format("DD/MM/YYYY HH:mm:ss")}
        </div>
      ),
    },
    {
      Header: <div style={{ textAlign: "left" }}>Submit Date</div>,
      accessor: "submitted_at",
      Cell: (props) => (
        <div>
          {!props.value
            ? "-"
            : momentTZ(props.value)
                .tz("Asia/Bangkok")
                .format("DD/MM/YYYY HH:mm:ss")}
        </div>
      ),
    },
    {
      Header: <div style={{ textAlign: "left" }}>Register By</div>,
      accessor: "member_type",
      Cell: (props) => <div>{REGISTER_BY(props.value)}</div>,
    },
    {
      Header: <div style={{ textAlign: "left" }}>Name</div>,
      accessor: "personal_first_name",
      Cell: (props) => (
        <div>
          {`${RENDER_CHARACTER_REPLACE_BY_PERMISSION({
            ...permission,
            inputString: props.value,
          })} ${RENDER_CHARACTER_REPLACE_BY_PERMISSION({
            ...permission,
            inputString: props.row.original.personal_last_name,
          })}`}
        </div>
      ),
    },
    {
      Header: <div style={{ textAlign: "left" }}>Email</div>,
      accessor: "personal_email",
      Cell: (props) => <div>{`${props.value || ""}`}</div>,
    },
    {
      Header: <div style={{ textAlign: "left" }}>Phone</div>,
      accessor: "personal_phone_number",
      Cell: (props) => <div>{`${props.value || ""}`}</div>,
    },
    {
      Header: <div style={{ textAlign: "left" }}>Check in</div>,
      accessor: "check_in",
      Cell: (props) => <div>{`${props.value ? "Y" : "N"}`}</div>,
    },
    {
      Header: <div style={{ textAlign: "left" }}>Approved</div>,
      accessor: "action",
      Cell: (props) => {
        return (
          <BtnApproveFormWidget
            id={props.row.original._id}
            value={props.row.original.status}
            onBgLoading={handleBgLoading}
            onSuccess={handleApproveeSuccess}
          />
        );
      },
    },
    {
      Header: <div style={{ textAlign: "left" }}>Reject</div>,
      accessor: "rejection_reason",
      Cell: (props) => <div>{props.value || "-"}</div>,
    },
  ];
  if (data.question_list && data.question_list.length > 0) {
    data.question_list.forEach((e, i) => {
      e.questions.forEach((f, j) => {
        temp.push({
          Header: (
            <div style={{ textAlign: "left" }}>{`Ans${e.page}/${j + 1}`}</div>
          ),
          accessor: `question_list${i + 1}${j + 1}`,
          Cell: (props) => {
            return (
              <AnswerOnlineFormEditWidget
                id={props.row.original._id}
                question_list_id={props.row.original.question_list[i]._id}
                data={props.row.original.question_list[i]?.questions[j]}
                onSuccess={onSuccess}
              />
            );
          },
        });
      });
    });
  }
  if (data.is_certificate) {
    temp.push({
      Header: <div style={{ textAlign: "left" }}>Certificate</div>,
      accessor: "certificate_file",
      Cell: (props) => (
        <div>
          <BtnUploadCerificateWidget
            acvityFormHistoryID={props.row.original._id}
            value={props.value}
            onBgLoading={handleBgLoading}
            onSuccess={handleApproveeSuccess}
          />
        </div>
      ),
    });
  }

  return temp;
};

const COLUMNS_REQUESTS = ({
  handleApproveeSuccess,
  handleBgLoading,
  permission,
}) => [
  {
    Header: <div style={{ textAlign: "left" }}>Create</div>,
    accessor: "created_at",
    Cell: (props) =>
      momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm"),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Register By</div>,
    accessor: "member_type",
    Cell: (props) => <div>{props.value === "1" ? "บุคคล" : "องค์กร"}</div>,
  },
  {
    Header: <div style={{ textAlign: "left" }}>Name</div>,
    accessor: "personal_first_name",
    Cell: (props) => (
      <div>
        {`${RENDER_CHARACTER_REPLACE_BY_PERMISSION({
          ...permission,
          inputString: props.value,
        })} ${RENDER_CHARACTER_REPLACE_BY_PERMISSION({
          ...permission,
          inputString: props.row.original.personal_last_name,
        })}`}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Email</div>,
    accessor: "personal_email",
    Cell: (props) => props.value,
  },
  {
    Header: <div style={{ textAlign: "left" }}>Phone</div>,
    accessor: "personal_phone_number",
    Cell: (props) => props.value,
  },
  {
    Header: <div style={{ textAlign: "left" }}>Admin Status</div>,
    accessor: "status",
    Cell: (props) => {
      const renderStatus = ACTIVITY_FORM_RENDER_STATUS(props.value);
      return (
        <Displays.StatusLabel
          bg={renderStatus?.bg}
          txtColor={renderStatus?.txtColor}
          label={renderStatus?.label}
        />
      );
    },
  },
  {
    Header: <div style={{ textAlign: "left" }}>Customer Status</div>,
    accessor: "cus_status",
    Cell: (props) => {
      const renderStatus = ACTIVITY_FORM_RENDER_CUS_STATUS(
        props.row.original.status,
      );
      return (
        <Displays.StatusLabel
          bg={renderStatus?.bg}
          txtColor={renderStatus?.txtColor}
          label={renderStatus?.label}
        />
      );
    },
  },
  {
    Header: <div style={{ textAlign: "center" }}>Edit/Action</div>,
    accessor: "action",
    Cell: (props) => {
      return props.row.original.status === "6" ? (
        <div style={{ textAlign: "center" }}>
          <BtnActivityActionFormWidget
            data={props.row.original}
            icon={<MdAssignmentAdd size={22} color="#F89900" />}
            value={props.row.original.status}
            onBgLoading={handleBgLoading}
            onSuccess={handleApproveeSuccess}
          />
        </div>
      ) : (
        <></>
      );
    },
  },
];

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(ActivityFormOfflineDetailContainer));
